module.exports = __webpack_public_path__ + "static/media/onboarding_recompense.bd500521.png";